<template>
    <div name="home" class="home">
        <div class="row">
            <div class="button1"  @click="gosignup">
                <img style="width: 18vw" src="../../../assets/showcase/bodyfriend/button1.png" />
                <div class="line"></div>
                <span class="button-text"><span style="font-weight: 700; color: #FFC800;">건강측정</span><br>체험하기</span>
            </div>
            <div class="button1" @click="gopreview">
                <img style="width: 18vw" src="../../../assets/showcase/bodyfriend/button2.png" />
                <div class="line"></div>
                <span class="button-text"><span style="font-weight: 700; color: #FFC800;">헬스케어 서비스</span><br>미리보기</span>
            </div>
            
        </div>
        <img style="width: 56vw; position: absolute; z-index: 0; bottom: 7vh;" src="../../../assets/showcase/bodyfriend/gif.gif" />
        
    </div>
</template>

<script>
import homeMixin from './homeMixin'

export default {
    name: 'SeoulOneHome',
    mixins: [homeMixin]
}
</script>

<style scoped>
    .home {
        width: 100%;
        height: 100dvh;
        background: url('../../../assets/showcase/bodyfriend/background.png') center/cover no-repeat;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        
    }
    .button1 {
        width: 40%;
        aspect-ratio: 440/535;
        display: flex;
        padding: 60px;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        gap: 40px;
        box-sizing: border-box;
        border-radius: 24px;
        border: 2px solid #FFF;
        background: linear-gradient(180deg, #000 43.86%, rgba(0, 0, 0, 0.00) 100%), rgba(255, 255, 255, 0.05);
        box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.40);
        backdrop-filter: blur(5px);
        cursor: pointer;
    }
    .line {
        height: 1px;
        background: #BAA43D;
        width: 7vw;
    }
    .button1 svg {
        width: 55%;
        height: auto;
    }
    .pointer-icon {
        width: 4vw;
        height: auto;
        color: #83674C;
    }
    .copyright {
        font-size: 2.4vw;
        color: #D1D1D1;
        font-family: "Pretendard Variable";
        font-weight: 500;
        opacity: 0.6;
        position: absolute;
        bottom: 2vh;

    }
    .text {
        font-size: 3vw;
        color: #83674C;
        text-align: center;
        font-family: "Pretendard Variable";
        font-style: normal;
        font-weight: 600;
        line-height:  300%;
        letter-spacing: -1.92px;
        height: 5vh;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .row {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        gap: 2vw;
        box-sizing: border-box;
        padding: 0 5vw;
        margin-top: 28vh;
        z-index: 12;
    }
    .button-text {
        color: #FFF;
        font-family: "Gmarket Sans";
        font-size: 3.7vw;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/showcase/home/Bodyfriend.vue